import InfinitelyScrollableContainer from "../../Utils/InfinitelyScrollableContainer";
import { useResponsiveFlag } from "../../Utils/ResponsiveQueries";
import { BoxSpinner } from "../../Utils/Spinner";
import ContributionCard from "./ContributionCard";
import { CONTRIBUTIONS_BATCH_SIZE } from "./ContributionsList";
import { ContributionsListWithNavigationFragment_participativeModule } from "./ContributionsListWithNavigationFragment";
import useFilterableContributionsList from "./useFilterableContributionsList";

const ContributionsListNavigation = props => {
  const { contributions, loadMore, isLoadingNext } = useFilterableContributionsList({
    contribuable: props.participativeModule,
    fragment: ContributionsListWithNavigationFragment_participativeModule,
    contributionsBatchSize: CONTRIBUTIONS_BATCH_SIZE
  });

  const { isNonDesktop } = useResponsiveFlag();
  const scrollableContainer = isNonDesktop ? null : props.scrollableContainer;

  if (!scrollableContainer && !isNonDesktop) return null;

  return (
    <InfinitelyScrollableContainer
      className="boxes-list"
      onBottomReached={loadMore}
      scrollableContainer={scrollableContainer}
      offset={300}
    >
      <ul className="padding-none">
        {contributions.map(contribution => (
          <ContributionCard
            key={contribution.id}
            itemId={contribution.id}
            itemType="contribution"
            contribution={contribution}
          />
        ))}
      </ul>

      {isLoadingNext && <BoxSpinner />}
    </InfinitelyScrollableContainer>
  );
};

export default ContributionsListNavigation;
